import { DEFAULT_LAYOUT } from '../base';
import { AppRouteRecordRaw } from '../types';

const MY_REPORT: AppRouteRecordRaw = {
  path: '/report',
  name: 'report',
  component: DEFAULT_LAYOUT,
  redirect: '/report/report',
  meta: {
    locale: 'menu.report',
    requiresAuth: true,
    icon: 'icon-file',
    order: 3,
    hideChildrenInMenu: true,
    activeMenu: 'report',
  },
  children: [
    {
      path: 'report',
      name: 'Report',
      component: () => import('@/views/report/index.vue'),
      meta: {
        locale: 'menu.report',
        requiresAuth: true,
        roles: ['*'],
      },
    },
  ],
};

export default MY_REPORT;
